import { AnalyticsDispatcher } from '../../internal/AnalyticsDispatcher';
import { withFilters as higherOrder } from '../../extenders';
function withFilters(filters) {
    return higherOrder(filters)(this);
}
AnalyticsDispatcher.prototype.withFilters = withFilters;
//# sourceMappingURL=withFilters.js.map